import React, { useEffect, useRef, useState } from 'react';
import { size } from '../../utils/Breakpoints';
import { ProductsContainer, Title, CardsContainer, CarouselContainer, ArrowButton } from './styles';
import Card from '../../components/Card/index';
import { useSpringCarousel } from 'react-spring-carousel-js';
import { createCarouselCards } from './functions';
import Modal from '../../components/Modal/Modal';

const Products = ({ productos }) => {
  const [itemsCarousel, setItemsCarousel] = useState([{ toLoad: true, id: 1, renderItem: 'loading...' }]);
  const [showModal, setOpenModal] = useState(false);
  const [modalInformation, setModalInformation] = useState({ title: null, description: null, details: null, image: null });
  const { carouselFragment, slideToPrevItem, slideToNextItem } = useSpringCarousel({
    items: itemsCarousel,
  });

  useEffect(() => {
    const pantalla = parseInt(window.innerWidth);
    let data = {};
    switch (true) {
      case pantalla >= size.large:
        data = {
          cantProductosPorPantalla: 3,
        };
        break;
      case pantalla >= size.med:
        data = {
          cantProductosPorPantalla: 2,
        };
        break;
      default:
        data = {
          cantProductosPorPantalla: 1,
        };
        break;
    }
    data.productos = productos;
    const createItemsCarousel = createCarouselCards(data, setOpenModal, showModal, setModalInformation);
    setItemsCarousel(createItemsCarousel);
  }, []);

  return (
    <>
      <ProductsContainer id={'productos'}>
        <Title>Productos destacados</Title>
        <CarouselContainer>
          <ArrowButton arrow='<' type='prev' onClick={slideToPrevItem} />
          {carouselFragment}
          <ArrowButton arrow='>' type='next' onClick={slideToNextItem} />
        </CarouselContainer>
        {/* <button onClick={openModal}>Modal</button> */}
        <Modal open={showModal} modalInformation={modalInformation} setOpen={setOpenModal} content={'hola'}></Modal>
      </ProductsContainer>
    </>
  );
};

export default Products;
